import { useQuery } from '@tanstack/react-query';
import { FIRST_PAGE } from 'data/global';
import useInvalidateQueryOnUnmount from 'hooks/useInvalidateQueryOnUnmount';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import { getAnalyticsTimeframeFilter } from 'router/subrouters/DataRoom/utils';
import { DataRoomNodeReport } from '../../../../Reports/types';
import { useContext } from 'react';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';

const FILE_ACTIVITY_QUERY_KEY = 'data-room-file-activity';
const LIMIT = '10';

type UseFileActivityQueryProps = {
  dataRoomId: string;
  sort: string;
};

export default function useFileActivityQuery({
  dataRoomId,
  sort,
}: UseFileActivityQueryProps) {
  const { preferredAnalyticsTimeframe } = useContext(DataRoomContext);

  const query = useQuery<DataRoomNodeReport[]>({
    queryKey: [
      FILE_ACTIVITY_QUERY_KEY,
      { dataRoomId, preferredAnalyticsTimeframe, sort },
    ],
    queryFn: async () => {
      const {
        data: { items },
      } = await dataRoomApi.reports.getReportByNodeActivity(dataRoomId, {
        $page: FIRST_PAGE,
        $limit: LIMIT,
        $sort: sort,
        ...getAnalyticsTimeframeFilter(preferredAnalyticsTimeframe),
      });

      return items;
    },
    enabled: !!dataRoomId,
  });

  useInvalidateQueryOnUnmount(FILE_ACTIVITY_QUERY_KEY);

  return {
    ...query,
    reports: query.data || [],
  };
}
